import { render, staticRenderFns } from "./ModuleGallery.vue?vue&type=template&id=1647f131&scoped=true"
import script from "./ModuleGallery.vue?vue&type=script&lang=js"
export * from "./ModuleGallery.vue?vue&type=script&lang=js"
import style0 from "./ModuleGallery.vue?vue&type=style&index=0&id=1647f131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647f131",
  null
  
)

export default component.exports